import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from "@react-oauth/google";



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  

    

<GoogleOAuthProvider clientId="244903806108-lmovisf9emd2ds1375u4rdrq4fbl1frb.apps.googleusercontent.com">
  <App />
</GoogleOAuthProvider>

  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
